import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toggleErrorState } from "@Components/LeadFormModal/data/leadFormReducer";
import styles from "./ErrorNotification.module.scss";
import CloseIcon from "@Icons/CloseIcon";
import InfoIcon from "@Icons/InfoIcon";
import wrapperHOC from "@Utils/wrapperHOC";

const ErrorNotification = ({ title, subtext }: { title?: string; subtext?: string }) => {
  const dispatch = useDispatch();

  const handleNotificationCloseClick = () => dispatch(toggleErrorState({ showError: false }));

  useEffect(() => {
    const timer = setTimeout(handleNotificationCloseClick, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={styles.container}>
      <InfoIcon fill="#F05252" height="24" width="24" />
      <div className={styles.textContainer}>
        <div className={styles.title}>{title ?? "Oops!"}</div>
        <div className={styles.subText}>
          {subtext ?? "There was an issue submitting the form. Please try again later."}
        </div>
      </div>
      <CloseIcon size={24} stroke="#F05252" />
    </div>
  );
};

export default wrapperHOC(ErrorNotification, {
  componentName: "ErrorNotification-Global",
  showForChina: true,
});
